import Analytics from 'react-ga';

import { getLoginToken } from '../api/login';

const launcherUrl = process.env.REACT_APP_LAUNCHER_URL;
const webappUrl = process.env.REACT_APP_WEBAPP_URL;
const shopUrl = process.env.REACT_APP_SHOP_URL;

async function redirectToShoppingCart(plan?: string | null, email?: string, password?: string) {
  if (!email || !password) {
    window.location.assign(shopUrl as string);
    return;
  }
  const currentUrl = new URL(window.location.href);
  const reseller = currentUrl.searchParams.get('reseller');
  const jwt = await getLoginToken(email, password);
  let url = `${shopUrl}/?jwt=${jwt}&plan=${plan}`;
  if (reseller) {
    url = url.concat(`&reseller=${reseller}`);
  }
  Analytics.event({
    action: 'continue checkout',
    category: 'ecom',
    label: plan || ''
  });
  window.location.assign(url);
}

async function redirectToWebapp(email?: string, password?: string) {
  if (!email || !password) {
    window.location.assign(webappUrl as string);
    return;
  }
  const jwt = await getLoginToken(email, password);
  Analytics.event({
    action: 'redirect to webapp',
    category: 'freemium get started'
  });
  window.location.assign(`${webappUrl}/?a=${jwt}`);
}

function redirectToAppleStore() {
  Analytics.event({
    action: 'redirect to apple app store',
    category: 'freemium get started'
  });
  window.location.assign('https://itunes.apple.com/us/app/lifesize-cloud/id854663434');
}

function redirectToPlayStore() {
  Analytics.event({
    action: 'redirect to google play store',
    category: 'freemium get started'
  });
  window.location.assign('https://play.google.com/store/apps/details?id=com.mirial.lifesizecloud');
}

function redirectToLauncher() {
  Analytics.event({
    action: 'redirect to launcher',
    category: 'freemium get started'
  });
  window.open(launcherUrl);
}

export { redirectToWebapp, redirectToPlayStore, redirectToLauncher, redirectToAppleStore, redirectToShoppingCart };
